<table class="simple" id="custom-hole-list">
  <thead>
    <tr>
      <th i18n>Название</th>
      <th i18n class="base-point-col">База</th>
      <th>x (mm)</th>
      <th>y (mm)</th>
      <th class="delete-col">
        <button [disabled]="!editable" mat-icon-button (click)="openAddHoleDialog()" matTooltip="Добавить">
          <mat-icon>add_circle_outline</mat-icon>
        </button>
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-container
      [ngTemplateOutlet]="holesRows"
      [ngTemplateOutletContext]="{
        holes: groupedHoles.face,
        clickHandler: toggleSelectedHole,
        deleteHandler: deleteCustomHole,
        isSelectedChecker: isSelectedHole
      }">
    </ng-container>
    <ng-container
      [ngTemplateOutlet]="holesRows"
      [ngTemplateOutletContext]="{
        holes: groupedSets.face,
        clickHandler: toggleSelectedFastenersSet,
        deleteHandler: deleteFastenerSet,
        isSelectedChecker: isSelectedFastenerSets
      }">
    </ng-container>

    <ng-container
      [ngTemplateOutlet]="holesRows"
      [ngTemplateOutletContext]="{
        holes: groupedHoles.back,
        clickHandler: toggleSelectedHole,
        deleteHandler: deleteCustomHole,
        isSelectedChecker: isSelectedHole
      }">
    </ng-container>
    <ng-container
      [ngTemplateOutlet]="holesRows"
      [ngTemplateOutletContext]="{
        holes: groupedSets.back,
        clickHandler: toggleSelectedFastenersSet,
        deleteHandler: deleteFastenerSet,
        isSelectedChecker: isSelectedFastenerSets
      }">
    </ng-container>

    <ng-container
      [ngTemplateOutlet]="holesRows"
      [ngTemplateOutletContext]="{
        holes: groupedHoles.edge,
        clickHandler: toggleSelectedHole,
        deleteHandler: deleteCustomHole,
        isSelectedChecker: isSelectedHole
      }">
    </ng-container>
    <ng-container
      [ngTemplateOutlet]="holesRows"
      [ngTemplateOutletContext]="{
        holes: groupedSets.edge,
        clickHandler: toggleSelectedFastenersSet,
        deleteHandler: deleteFastenerSet,
        isSelectedChecker: isSelectedFastenerSets
      }">
    </ng-container>

    <ng-template
      #holesRows
      let-holes="holes"
      let-isSelectedChecker="isSelectedChecker"
      let-clickHandler="clickHandler"
      let-deleteHandler="deleteHandler">
      <tr
        *ngFor="let item of holes"
        class="hole-row"
        (click)="clickHandler(item, this)"
        [ngClass]="{ selected: isSelectedChecker(item, this) }">
        <td>{{ item.name }}</td>
        <td class="base-point-col">
          <csl-base-point-thumbnail [active]="getBasePointLocalizedName(item.side, item.basePoint)">
          </csl-base-point-thumbnail>
        </td>
        <td>{{ item.x }}</td>
        <td>{{ item.y }}</td>
        <td class="delete-col">
          <button [disabled]="!editable" mat-icon-button (click)="deleteHandler(item, this)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </tr>
    </ng-template>
  </tbody>
</table>
